import EN_US from './ts/en-US';

// en-US stays static: react-localization's fallback, and raw_strings reads it at module scope
const packs = { 'en-US': EN_US };
const crossingLocaleSubsets = {};

export const registerLocale = (code, translations) => {
  packs[code] = translations;
};

export const registerCrossingLocaleSubset = (code, translations) => {
  crossingLocaleSubsets[code] = translations;
};

// pick, not merge: merging deep-clones all 64 locales at module scope in the server bundle
export const localeStringsFor = code => packs[code] || crossingLocaleSubsets[code];
